import {DecreaseArrowIcon, IncreaseArrowIcon} from "./Icons";
import { formatINR } from "@/utils/goldSilverParser";
export default function CurrentPriceCards({colors={}, isGold=true, currentPriceData=null}) {
    const goldTrendChecks = {
        trend24: (isGold && currentPriceData?.trend24 == "increase"),
        trend22: (isGold && currentPriceData?.trend22 == "increase"),
        trend18: (isGold && currentPriceData?.trend18 == "increase"),
    }
    const silverTrendCheck = {
        trendOneGram : (!isGold && currentPriceData?.trendOneGram == "increase"),
        trendOneKg: (!isGold && currentPriceData?.trendOneKg == "increase"),
    }

    return(
        <div className="w-full flex gap-1.5 py-4 border-b border-zinc-400">
            
            <div className={`${isGold? "w-1/3":"w-1/2"} ${colors.gradient} flex flex-col gap-y-1 px-2  md:px-4 py-2.5 rounded-lg`}>
                <span className="self-center md:self-start text-sm">
                    {isGold?"24K Gold/g": "Silver/g"}
                </span>
                <div className="flex flex-col md:flex-row justify-between items-center">
                    <span className="text-xl font-semibold">
                        {isGold? formatINR(currentPriceData?.oneGram?.carat24) : formatINR(currentPriceData?.oneGram)}
                    </span>
                    <span className={`inline-flex text-semibold items-center gap-x-1 text-sm rounded-2xl px-1.5 py-1 border ${(goldTrendChecks.trend24||silverTrendCheck.trendOneGram)? "text-green-500 border-green-500": "text-red-500 border-red-500"}`}>
                        {(goldTrendChecks.trend24||silverTrendCheck.trendOneGram)? "+ " : "- "}
                        {isGold? currentPriceData?.difference24 : currentPriceData?.differenceOneGram}
                        {(goldTrendChecks.trend24||silverTrendCheck.trendOneGram)? <IncreaseArrowIcon /> : <DecreaseArrowIcon />}
                    </span>
                </div>
            </div>

            <div className={`${isGold? "w-1/3":"w-1/2"} ${colors.gradient} flex flex-col gap-y-1 px-4 py-2.5 rounded-lg`}>
                <span className="self-center md:self-start text-sm">
                    {isGold?"22K Gold/g": "Silver/kg"}
                </span>
                <div className="flex flex-col md:flex-row justify-between items-center">
                    <span className="text-xl font-semibold">
                        {isGold? formatINR(currentPriceData?.oneGram?.carat22) : formatINR(currentPriceData?.oneKg)}
                    </span>
                    <span className={`inline-flex text-semibold items-center gap-x-1 text-sm rounded-2xl px-1.5 py-1 border ${(goldTrendChecks.trend22||silverTrendCheck.trendOneKg)? "text-green-500 border-green-500": "text-red-500 border-red-500"}`}>
                        {(goldTrendChecks.trend22||silverTrendCheck.trendOneKg)? "+ " : "- "}
                        {isGold? currentPriceData?.difference22 : currentPriceData?.differenceOneKg}
                        {(goldTrendChecks.trend22||silverTrendCheck.trendOneKg)? <IncreaseArrowIcon /> : <DecreaseArrowIcon />}
                    </span>
                </div>
            </div>

            {isGold && <div className={`w-1/3 ${colors.gradient} flex flex-col gap-y-1 px-4 py-2.5 rounded-lg`}>
                <span className="self-center md:self-start text-sm">
                    {"18K Gold/g"}
                </span>
                <div className="flex flex-col md:flex-row justify-between items-center">
                    <span className="text-xl font-semibold">
                        {formatINR(currentPriceData?.oneGram?.carat18)}
                    </span>
                    <span className={`inline-flex text-semibold items-center gap-x-1 text-sm rounded-2xl px-1.5 py-1 border ${(goldTrendChecks.trend18)? "text-green-500 border-green-500": "text-red-500 border-red-500"}`}>
                        {(goldTrendChecks.trend18)? "+ " : "- "}
                        {currentPriceData?.difference18}
                        {(goldTrendChecks.trend18)? <IncreaseArrowIcon /> : <DecreaseArrowIcon />}
                    </span>
                </div>
            </div>}
        </div>
    )
}